import axios from 'axios';

export default async function resendVerificationEmail(email: string) {
  const URL = `${process.env.REACT_APP_API_URL}/api/auth/send-email-confirmation`;
  const response = await axios.post(URL, { email });
  return response.data;
}
